import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-pop-up-message',
  templateUrl: './pop-up-message.component.html',
  styleUrls: ['./pop-up-message.component.css']
})
export class PopUpMessageComponent {

  comment = '';
  requestId: string = '';

  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<PopUpMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { comment: string, requestId: string }
  ) {
    this.requestId = data.requestId;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  sendOption(): void {
    const option = this.comment;
    const status = 'rejected';
    const rejectionReason = option;

    this.apiService.putSubscriptionRequestById(this.requestId, status, rejectionReason).subscribe(
      () => {
        this.dialogRef.close(status);
      },
      (error) => {
        console.error('Error denying request:', error);
      }
    );
  }

}
